//#region IMPORTS
import React from 'react';
//redux
import { getConciliationListBank } from '../../redux/conciliationMonitor.duck';
import { columns } from './conciliationShared';
import ConciliationPartial from './shared/ConciliationPartial';
//#endregion IMPORTS

// Estilo para las filas que no coinciden con el banco
const conditionalRowStyles = [
  {
    when: row => row.statusBank === 'NOT_MATCH',
    style: {
      backgroundColor: '#dc3545',
      color: 'white',
      '&:hover': {
        cursor: 'not-allowed',
      },
    },
  },
];
const codeSapCol = { xs: 4, sm: 4, md: 4, lg: 4 };
// Se mantiene el comportamiento original: el CI se limpia segun el filtro de nombre
const resetFlags = { clientCi: 'filterClientName' };

const PartialBank = ({ data }) => (
  <ConciliationPartial
    data={data}
    fetchAction={getConciliationListBank}
    columns={columns}
    conditionalRowStyles={conditionalRowStyles}
    codeSapCol={codeSapCol}
    resetFlags={resetFlags}
  />
);
export default PartialBank;
